import React from 'react';

import type { FC } from 'react';

export const GridOn: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path d="M13.3333 1.33301H2.66666C1.93333 1.33301 1.33333 1.93301 1.33333 2.66634V13.333C1.33333 14.0663 1.93333 14.6663 2.66666 14.6663H13.3333C14.0667 14.6663 14.6667 14.0663 14.6667 13.333V2.66634C14.6667 1.93301 14.0667 1.33301 13.3333 1.33301ZM5.33333 13.333H3.33333C2.96666 13.333 2.66666 13.033 2.66666 12.6663V10.6663H5.33333V13.333ZM5.33333 9.33301H2.66666V6.66634H5.33333V9.33301ZM5.33333 5.33301H2.66666V3.33301C2.66666 2.96634 2.96666 2.66634 3.33333 2.66634H5.33333V5.33301ZM9.33333 13.333H6.66666V10.6663H9.33333V13.333ZM9.33333 9.33301H6.66666V6.66634H9.33333V9.33301ZM9.33333 5.33301H6.66666V2.66634H9.33333V5.33301ZM12.6667 13.333H10.6667V10.6663H13.3333V12.6663C13.3333 13.033 13.0333 13.333 12.6667 13.333ZM13.3333 9.33301H10.6667V6.66634H13.3333V9.33301ZM13.3333 5.33301H10.6667V2.66634H12.6667C13.0333 2.66634 13.3333 2.96634 13.3333 3.33301V5.33301Z" />
      </g>
    </svg>
  );
};
